import React from 'react';

import Content from './Content';

const JobOrders = props => {
  return <Content {...props} />;
};

export default JobOrders;
